/*
 * Signing in, signing up and the account page (decision 0033), in the business app's look (.biz tokens
 * from business.css): what a new company sees first.
 */
.auth {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 520px);
  min-height: 100vh;
}
.auth-aside {
  position: relative;
  overflow: hidden;
  padding: 48px 56px;
  background: var(--promo-a);
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.auth-aside .biz-brand {
  color: #fff;
}
.auth-aside .biz-brand small {
  color: rgb(255 255 255 / 0.75);
}
.auth-aside .biz-mark {
  background: rgb(255 255 255 / 0.18);
}
.auth-aside h2 {
  font-size: 34px;
  line-height: 1.2;
  font-weight: 300;
  letter-spacing: 1px;
  max-width: 16ch;
  margin-top: auto;
}
.auth-aside ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 14px;
  max-width: 44ch;
}
.auth-aside li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  color: rgb(255 255 255 / 0.92);
}
.auth-aside li svg {
  flex: none;
  margin-top: 2px;
}
.auth-aside .fine {
  margin-top: auto;
  font-size: 12.5px;
  color: rgb(255 255 255 / 0.7);
}
.auth-main {
  display: grid;
  place-items: center;
  padding: 40px 24px;
  background: var(--bg);
}
.auth-card {
  width: min(400px, 100%);
}
.auth-card h1 {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 1px;
}
.auth-card > p.lead {
  margin: 8px 0 24px !important;
  color: var(--muted);
}
.auth-form {
  display: grid;
  gap: 16px;
}
.auth-field {
  display: grid;
  gap: 6px;
}
.auth-field > label {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-2);
}
.auth-field .row-label {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.auth-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border-radius: var(--radius);
  border: 1px solid var(--line-2);
  background: var(--surface);
  color: var(--ink);
  font: 400 15px var(--font);
  outline: none;
}
.auth-input:focus {
  border-color: var(--primary);
  box-shadow: inset 0 0 0 1px var(--primary);
}
.auth-input[aria-invalid='true'] {
  border-color: var(--bad);
}
.auth-input.code {
  font: 500 22px var(--mono);
  letter-spacing: 0.3em;
  text-align: center;
}
.auth-reveal {
  position: relative;
}
.auth-reveal .auth-input {
  padding-right: 48px;
}
.auth-reveal button {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: var(--radius);
  background: none;
  color: var(--faint);
  display: grid;
  place-items: center;
  cursor: pointer;
}
.auth-err {
  font-size: 12.5px;
  color: var(--bad);
}
.auth-alert {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: var(--radius);
  font-size: 13.5px;
  background: var(--bad-soft);
  color: var(--ink-2);
}
.auth-alert svg {
  flex: none;
  margin-top: 2px;
  color: var(--bad);
}
.auth-alert.ok {
  background: var(--ok-soft);
}
.auth-alert.ok svg {
  color: var(--ok);
}
.auth-alert.info {
  background: var(--primary-soft);
}
.auth-alert.info svg {
  color: var(--primary);
}
.auth-submit {
  width: 100%;
  height: 46px;
}
.auth-alt {
  margin-top: 22px !important;
  text-align: center;
  color: var(--muted);
}
.auth .link {
  color: var(--primary);
  font-weight: 500;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  font: inherit;
}
.rules {
  list-style: none;
  margin: 2px 0 0;
  padding: 0;
  display: grid;
  gap: 4px;
  font-size: 12.5px;
  color: var(--faint);
}
.rules li {
  display: flex;
  gap: 6px;
  align-items: center;
}
.rules li.ok {
  color: var(--ok);
}
.dev-signin {
  margin-top: 28px;
  border-top: 1px dashed var(--line-2);
  padding-top: 16px;
}
.dev-signin summary {
  cursor: pointer;
  color: var(--faint);
  font-size: 13px;
}
.dev-signin .list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}
.dev-signin .bbtn {
  justify-content: space-between;
  height: auto;
  padding: 10px 14px;
  border-radius: var(--radius);
  border-color: var(--card-line);
  color: var(--ink);
  font-size: 14px;
  letter-spacing: normal;
  text-transform: none;
  white-space: normal;
  text-align: left;
}

/* Two-step setup and the account page */
.qr {
  display: grid;
  place-items: center;
  padding: 14px;
  border-radius: var(--radius);
  background: #fff;
  border: 1px solid var(--line);
  width: fit-content;
}
.qr svg {
  width: 180px;
  height: 180px;
}
.secret {
  font: 500 14px var(--mono);
  letter-spacing: 0.08em;
  word-break: break-all;
  padding: 10px 12px;
  border-radius: var(--radius);
  background: var(--sunken);
}
.codes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  font: 500 15px var(--mono);
  padding: 14px;
  border-radius: var(--radius);
  background: var(--sunken);
}
.setup-steps {
  display: grid;
  gap: 18px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.setup-steps > li {
  display: grid;
  gap: 10px;
}
.account-grid {
  display: grid;
  gap: 18px;
  max-width: 760px;
}
.session-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid var(--line);
}
.session-row:first-child {
  border-top: 0;
}
.session-row .grow {
  flex: 1;
  min-width: 0;
}
.gate {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px 16px;
  background: var(--bg);
}
.gate .bcard {
  width: min(560px, 100%);
}

@media (max-width: 900px) {
  .auth {
    grid-template-columns: 1fr;
  }
  .auth-aside {
    padding: 22px 16px;
    gap: 14px;
  }
  .auth-aside h2,
  .auth-aside ul,
  .auth-aside .fine {
    display: none;
  }
  .auth-main {
    place-items: start center;
    padding: 28px 16px 40px;
  }
}
